import React, { useRef, useState, useEffect } from 'react';
import { mergeRanges, watchedSegment } from './mediaProgress';

export default function TrainingVideo({ content, onProgress }) {
    const video = useRef(null);
    const ranges = useRef(content.watchtime?.watched_ranges || []);
    const sample = useRef({ time: null, clock: 0 });
    const lastSave = useRef(0);
    const [error, setError] = useState('');
    const callback = useRef(onProgress);
    callback.current = onProgress;
    const snapshot = () => ({
        media_duration: Number.isFinite(video.current?.duration) ? video.current.duration : 0,
        watched_ranges: ranges.current,
        watch_time: video.current?.currentTime || 0,
    });
    const record = () => {
        const player = video.current;
        if (!player || player.seeking) return;
        const now = performance.now();
        const segment = watchedSegment(sample.current.time, player.currentTime, (now - sample.current.clock) / 1000, player.playbackRate);
        if (segment) ranges.current = mergeRanges([...ranges.current, segment]);
        sample.current = { time: player.currentTime, clock: now };
    };
    const save = () => callback.current(snapshot());
    useEffect(() => {
        const player = video.current;
        return () => {
            if (player && Number.isFinite(player.duration)) callback.current({ media_duration: player.duration, watched_ranges: ranges.current, watch_time: player.currentTime });
        };
    }, []);
    return <div className="training-player">
        <video ref={video} controls preload="metadata" poster={content.thumbnail || undefined} src={content.file}
            onLoadedMetadata={() => {
                const position = Number(content.watchtime?.watch_time || 0);
                if (position < video.current.duration) video.current.currentTime = position;
            }}
            onPlay={() => { sample.current = { time: video.current.currentTime, clock: performance.now() }; }}
            onSeeking={() => { sample.current.time = null; }}
            onSeeked={() => { sample.current = { time: video.current.currentTime, clock: performance.now() }; }}
            onTimeUpdate={() => {
                record();
                if (performance.now() - lastSave.current > 10000) { lastSave.current = performance.now(); save(); }
            }}
            onPause={() => { record(); save(); }}
            onEnded={() => { record(); save(); }}
            onError={() => setError('Não foi possível carregar o vídeo. Atualize a página para tentar novamente.')}
        />
        {error && <p className="alert alert-danger" role="alert">{error}</p>}
        <p className="training-hint">Assista ao vídeo completo para liberar a conclusão e as questões. Trechos pulados precisam ser assistidos.</p>
    </div>;
}
